/* Duas coisas no botão de Add to cart (PDP real E quick add compacto, ver
 * snippets/ws-size-gate.liquid e assets/ws-quick-size.js pro <script>
 * síncrono que gateia cada um no load, com aria-disabled + texto
 * "Select size") enquanto a cliente troca de tamanho:
 *
 * 1. Mostra o mesmo spinner de loading (.loading/.loading__spinner nativos,
 *    já usados por assets/product-form.js no submit real e por
 *    assets/quick-add.js no opener) enquanto o fetch de troca de variante
 *    (assets/product-info.js) está em andamento — nativamente o Dawn só
 *    troca o atributo disabled nesse meio-tempo, sem indicação visual.
 * 2. Reverte o aria-disabled/texto assim que uma variante de verdade é
 *    confirmada (PUB_SUB_EVENTS.variantChange) — o Dawn nunca mexe no
 *    aria-disabled que o gate seta (só no atributo disabled, via
 *    toggleSubmitButton), então precisa ser revertido à mão aqui.
 *
 * Não escopa por dentro/fora de <quick-add-modal> — o botão dentro do
 * quick add compacto é a mesma marcação (buy-buttons.liquid, core) e o
 * mesmo gate (assets/ws-quick-size.js prepara o estado inicial, este
 * arquivo reage às trocas), então tratar os dois product-info da mesma
 * forma é o comportamento certo, não uma sobreposição.
 */
(function () {
  if (window.wsSizeGateInitialized) return;
  window.wsSizeGateInitialized = true;

  function gatedSubmitButton(productInfo) {
    return productInfo?.querySelector('.product-form__submit') ?? null;
  }

  // O quick add (assets/quick-add.js, preventDuplicatedIDs) reescreve
  // data-section do product-info fetchado pra "quickadd-<original>" e
  // guarda o valor ORIGINAL em data-original-section — mas o sectionId que
  // product-info.js publica em PUB_SUB_EVENTS.variantChange é sempre o
  // getter `dataset.originalSection || dataset.section` (assets/product-info.js),
  // ou seja, o valor ORIGINAL, nunca o reescrito. document.querySelector
  // por data-section sozinho nunca acha o product-info do quick add (bug
  // real, achado ao vivo: spinner nunca desligava depois de escolher
  // tamanho no quick add). Procura pelas duas possibilidades, mesma lógica
  // do getter nativo.
  //
  // Só o section id não diz QUAL product-info publicou (bug achado ao vivo
  // em 25/09/2026). Na PDP, o quick add do "Style it with"
  // (sections/ws-style-with.liquid) busca outro produto do mesmo template,
  // então o data-original-section dele é igual ao data-section do
  // product-info da própria PDP, que vem antes no documento (o
  // quick-add-modal é movido pro fim do <body>). Pegar o primeiro que bate
  // tirava o spinner e o gate do botão da PDP, sem tamanho escolhido, e
  // deixava o botão do quick add carregando pra sempre. O desempate é pela
  // variante: product-info.js grava o id dela no input do próprio form
  // (updateVariantInputs) logo antes do publish, então quem publicou é o
  // candidato cujo input já tem o id do evento. Sem nenhum que bata, fica o
  // primeiro, como antes.
  function productInfoForVariantChange(data) {
    var variantId = data.variant ? String(data.variant.id) : null;
    var first = null;
    var all = document.querySelectorAll('product-info');
    for (var i = 0; i < all.length; i++) {
      if ((all[i].dataset.originalSection || all[i].dataset.section) !== data.sectionId) continue;
      var idInput = all[i].querySelector('.product-variant-id');
      if (variantId && idInput && idInput.value === variantId) return all[i];
      if (!first) first = all[i];
    }
    return first;
  }

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    var target = event.data.target;
    if (target?.dataset?.optionName?.trim().toLowerCase() !== 'size') return;

    var submitButton = gatedSubmitButton(target.closest('product-info'));
    var spinner = submitButton?.querySelector('.loading__spinner');
    if (!submitButton || !spinner) return;

    submitButton.classList.add('loading');
    spinner.classList.remove('hidden');
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var productInfo = productInfoForVariantChange(event.data);
    var submitButton = gatedSubmitButton(productInfo);
    if (!submitButton) return;

    submitButton.classList.remove('loading');
    submitButton.querySelector('.loading__spinner')?.classList.add('hidden');

    if (event.data.variant && submitButton.getAttribute('aria-disabled') === 'true') {
      submitButton.removeAttribute('aria-disabled');
      submitButton.removeAttribute('data-ws-size-gated');

      // O texto só volta ao original quando a variante dá pra comprar.
      // Bug pré-existente achado em 21/09/2026: escolher um tamanho
      // ESGOTADO como PRIMEIRA seleção deixava o botão escrito "Add to
      // cart" (desabilitado, mas mentindo) — o Dawn acabava de escrever
      // "Sold out" via toggleSubmitButton e esta restauração passava por
      // cima. Só acontecia nessa ordem: escolhendo antes um tamanho
      // disponível, o gate já tinha sido liberado e este bloco não rodava,
      // que foi como o caso passou batido nos testes anteriores.
      if (event.data.variant.available) {
        var textEl = submitButton.querySelector('span');
        if (textEl && submitButton.dataset.wsOriginalText) {
          textEl.textContent = submitButton.dataset.wsOriginalText;
        }
      }
    }
  });
})();
